/* Phone heading sizes (2026-10-18, owner request).
   Under 750px wide, big headings in the page content (h1, h2 or h3 set at 24px or more) get one
   fixed size: page titles (h1) at most 32px, section headings (h2, h3) at most 28px. Smaller
   headings keep their own size. Long headings wrap to two even lines (text-wrap: balance) and are
   never shrunk to fit one line. The swatch pop-up title is left alone: swatch-2026.css keeps it on
   one line. Desktop is untouched. Loaded from layout/theme.liquid. */
(function () {
  var BIG = 24, H1 = 32, H2 = 28, MQ = window.matchMedia('(max-width: 749px)');
  var SEL = 'main h1, main h2, main h3, #MainContent h1, #MainContent h2, #MainContent h3';
  var SKIP = '.swatch-variant-modal';

  function reset(el) {
    el.style.removeProperty('font-size');
    el.style.removeProperty('text-wrap');
  }

  function size(el) {
    reset(el);
    if (!el.offsetWidth || el.closest(SKIP)) return;
    var base = parseFloat(getComputedStyle(el).fontSize);
    if (base < BIG) return;
    var cap = el.tagName === 'H1' ? H1 : H2;
    if (base > cap) el.style.fontSize = cap + 'px';
    el.style.textWrap = 'balance';
  }

  function run() {
    var els = document.querySelectorAll(SEL);
    for (var i = 0; i < els.length; i++) {
      if (MQ.matches) size(els[i]); else reset(els[i]);
    }
  }

  var t;
  function later() { clearTimeout(t); t = setTimeout(run, 120); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(run);
  window.addEventListener('load', run);
  if (MQ.addEventListener) MQ.addEventListener('change', run); else window.addEventListener('resize', later);
  if (window.MutationObserver) {
    var root = document.querySelector('main') || document.getElementById('MainContent') || document.body;
    new MutationObserver(later).observe(root, { childList: true, subtree: true });
  }
})();
